export default {
  palette: {
    primary: {
      main: '#2b94f3',
    },
    secondary: {
      main: '#d83b18',
    },
  },
};
